import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-search\">\n<path d=\"M89,20.9c-36.6,0-66.3,29.7-66.3,66.3c0,36.6,29.7,66.3,66.3,66.3c36.6,0,66.3-29.7,66.3-66.3\n\tC155.4,50.6,125.7,20.9,89,20.9z M89,131.4c-24.4,0-44.2-19.8-44.2-44.2C44.8,62.8,64.6,43,89,43c24.4,0,44.2,19.8,44.2,44.2\n\tC133.2,111.7,113.5,131.4,89,131.4z\" />\n<path d=\"M173.3,168.8l-6.3,6.3c-3,3-7.8,3-10.8,0l-39.2-39.2l17.1-17.1l39.2,39.2C176.2,160.9,176.2,165.8,173.3,168.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/search.svg
// module id = Bx0U
// module chunks = 3